<app-page-title [title]="'Scholarship Application'"></app-page-title>

<div class="row">
    <div class="col-md-12">
        <p>Congratulations on achieving a score of 60 or higher on your CAEL Test. Because of your achievement, you are eligible to apply for the CAEL Scholarships.</p>
    </div>
</div>

<div class="row">
    <div class="col-md-12">
        <p>The CAEL Scholarships eligibility requirements can be found
            <a
                href={{scholarshipURL}}
                target="_blank"
            > here.
            </a>
        </p>
        Click<a
            href={{scholarshipTermsURL}}
            target="_blank"
        > here </a>to read the complete terms and conditions for the CAEL Scholarships program.<br /><br />
    </div>
</div>

<div class="row">
    <div class="col-md-12">
        CAEL Scholarships Application essay submission requirements:
        <ul>
            <li>Your essay must be submitted as a PDF</li>
            <li>Your essay cannot exceed 500 words in length</li>
            <li>Once you have completed your essay, attach the file below and press “Submit”</li>
        </ul>
    </div>
</div>

<div class="row">
    <div class="col-md-12">
        <p>
            Your CAEL score represents a significant milestone in achieving your language learning and educational goals so far. <br />
        </p>
        <p class="essayTopic">
            Describe how you will use your opportunity to study in Canada to make a change in your life and/or the lives of others. How will being able to speak, read, listen, and write in English enable this change?
        </p>

        <div class="col-md-7">
            <div>
                <form
                    [formGroup]="userForm"
                    (ngSubmit)="onSubmit()"
                >
                    <fieldset>
                        <div>
                            <label>Essay Submission(PDF only) <span class="required fa fa-asterisk"></span></label>
                            <input
                                type="file"
                                style="height:43px;"
                                name="file"
                                ngf-pattern=".pdf"
                                ngf-max-size="1MB"
                                class="form-control align-middle"
                                formControlName="essayFile"
                                [(ngModel)]="essayFile"
                                (change)="fileChangeEvent($event)"
                            />
                        </div>
                        <div *ngIf="!fileTypeInvalid">
                            <br />
                            <div
                                class="alert alert-danger"
                                role="alert"
                            >
                                <p>The chosen file is not valid. Only files with ".pdf" extension can be uploaded.</p>
                            </div>
                        </div>
                        <div *ngIf="!fileSizeInvalid">
                            <br />
                            <div
                                class="alert alert-danger"
                                role="alert"
                            >
                                <p>The chosen file is too large. The maximum file size is 5 mb.</p>
                                <p>Please choose another file.</p>
                            </div>
                        </div>
                    </fieldset>
                    <br>
                    <p>Please indicate your program type and institution name:</p>
                    <div>
                        <div *ngFor="let program of programTypeList">
                            <input
                                type="radio"
                                name="programType"
                                id="{{program}}"
                                value="{{program}}"
                                formControlName="programType"
                                (change)="isOtherProgramSelected = false"
                            >
                            <span>&nbsp;</span>
                            <label for="{{program}}">{{program}}</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="programType"
                                id="other-program"
                                formControlName="programType"
                                (change)="isOtherProgramSelected = true;"
                            >
                            <span>&nbsp;</span>
                            <label for="other-program"> Other (please specify)</label>
                        </div>

                        <div>
                            <input
                                type="text"
                                name="programType"
                                class="form-control"
                                id="other-program"
                                *ngIf="isOtherProgramSelected"
                                formControlName="programType"
                            >
                        </div>

                    </div>
                    <p>Name of Institution:</p>
                    <div>
                        <input
                            name="institutionName"
                            type="text"
                            class="form-control"
                            formControlName="institutionName"
                        >
                    </div>
                    <br>
                    <div>
                        <label>
                            <input
                                type="checkbox"
                                class="mr-2"
                                name="scholarshipAgreement"
                                (change)="scholarshipAgreement = !scholarshipAgreement"
                            />
                            <span>I have read and agree to the terms and conditions for the CAEL Scholarships Program.</span>
                        </label>
                    </div>
                    <div>
                        <button
                            type="submit"
                            class="btn btn-primary has-spinner"
                            [disabled]="!scholarshipAgreement || userForm.invalid"
                        >
                            Submit
                        </button>
                    </div>
                </form>

            </div>

        </div>
    </div>
</div>
